import axios from 'axios'

export const apiExternal = axios.create()

export const apiPublic = axios.create({
  headers: { 'x-origin': 'web-app/user-web' }
})

export const apiPrivate = axios.create({
  headers: {'Authorization': ' ', 'x-origin': 'web-app/user-web'}
})



// WEBPACK FOOTER //
// ./src/api.js